import AfipProvider from "@/modules/afip/providers/AfipProvider";
import {ClientError} from "@dracul/common-frontend";
import FacturaProvider from "@/modules/afip/providers/FacturaProvider";

export default{
    props: {
        receipt: {type: Object},
    },
    data() {
        return {
            ebLoading: false,
            errorMessage: null,
            qrAfip: null,
            facturaPdfUrl: null,
            ticketFacturaUrl: null,
        }
    },
    computed:{
        NombreFantasia(){
            return this.$store.getters.getSettingValue('NombreFantasia')
        },
        NombreLegal(){
            return this.$store.getters.getSettingValue('NombreLegal')
        },
        Domicilio(){
            return this.$store.getters.getSettingValue('Domicilio')
        },
        CondicionIva(){
            return this.$store.getters.getSettingValue('CondicionIva')
        },

        IngresosBrutos(){
            return this.$store.getters.getSettingValue('IngresosBrutos')
        },

        InicioActividades(){
            return this.$store.getters.getSettingValue('InicioActividades')
        },

        CUIT(){
            return this.$store.getters.getSettingValue('CUIT')
        },
        getCbteTipoList(){
          if(this.CondicionIva === 'Responsable Inscripto'){
              return [{value: 1, text: "A"}, {value: 6, text: "B"}]
          }else if(this.CondicionIva === 'Responsable Monotributo'){
              return [{value: 11, text: "C"}]
          }else{
              return []
          }
        },
        getCbteLetter() {
            return CbteTipo => {
                switch (CbteTipo) {
                    case 11:
                        return "C"
                    case 6:
                        return "B"
                    case 1:
                        return "A"
                    default:
                        return ""
                }
            }

        },
        completeZeros() {
            return (number, zeros) => {
                if(number){
                    let count = number ? number.toString().length : 0
                    return Array(zeros - count + 1).join("0") + number
                }
            }

        }
    },
    methods: {
        getFacturaPdf() {
            if (this.receipt && this.receipt.Estado == 'FACTURADO') {
                AfipProvider.getFacturaPdf(this.receipt.id)
                    .then(r => {
                        this.facturaPdfUrl = r.data.getFacturaPdf
                        setTimeout(() => window.open(this.facturaPdfUrl), 300)
                    })
            }
        },
        getTicketFactura() {
            if (this.receipt && this.receipt.Estado == 'FACTURADO') {
                AfipProvider.getTicketFactura(this.receipt.id)
                    .then(r => {
                        this.ticketFacturaUrl = r.data.getTicketFactura
                        setTimeout(() => window.open(this.ticketFacturaUrl), 300)
                    })
            }
        },
        getQrAfip() {
            if (this.receipt && this.receipt.Estado == 'FACTURADO') {
               this.fetchQrAfip(this.receipt.id)
            }
        },
        fetchQrAfip(receiptId){
            AfipProvider.getQrAfip(receiptId)
                .then(r => {
                    this.qrAfip = r.data.getQrAfip
                })
        },
        emitirFactura(){
            this.ebLoading = true
            this.errorMessage = null
            AfipProvider.createElectronicBilling(this.receipt.id)
                .then(r => {
                    this.$emit("emitted",r.data.createElectronicBilling)
                    this.fetchQrAfip(this.receipt.id)
                })
                .catch(error => {
                    let clientError = new ClientError(error)
                    this.errorMessage = clientError.errorMessage
                })
                .finally(()=> this.ebLoading = false)
        },
        updateFactura(){
            this.ebLoading = true
            FacturaProvider.updateFactura(this.receipt.id,this.receipt).then(r => {
                console.log("r.data.updateFactura", r.data.updateFactura)
                this.$emit('input',r.data.updateFactura)
                this.$nextTick(()=>{
                    console.log('receipt', this.receipt)
                })
            }).finally(()=> this.ebLoading = false)
        }
    }
}
